import type React from 'react'

import css from './styles.module.css'

export const DescriptionWrapper: React.FC<React.PropsWithChildren> = ({
  children,
}) => <div className={css.description}>{children}</div>
